import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('sdb-sliding-panel')
export class SdbSlidingPanel extends LitElement {

    @property({ type: Boolean, reflect: true })
    accessor opened = false;

    @property({ type: String })
    accessor header = '';

    @property({ type: String })
    accessor width = '400px';

    static styles = css`
        :host {
            position: fixed;
            top: 0;
            right: 0;
            height: 100%;
            display: block;
            z-index: 1000;
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.5);
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.3s ease;
        }

        :host([opened]) .overlay {
            opacity: 1;
            pointer-events: auto;
        }

        .panel {
            position: fixed;
            top: 0;
            right: 0;
            height: 100%;
            background: #fff;
            box-shadow: -2px 0 6px rgba(0, 0, 0, 0.3);
            transform: translateX(100%);
            transition: transform 0.3s ease;
            display: flex;
            flex-direction: column;
        }

        :host([opened]) .panel {
            transform: translateX(0);
        }

        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            border-bottom: 1px solid #ddd;
        }

        header span {
            margin-left: 1rem;
            font-size: 1.2rem;
        }

        header sdb-content-icon {
            margin-right: 1rem;
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            padding: .7rem;
        }

        header sdb-content-icon:hover {
            transform: var(--sdb-button-scale-factor, scale(1.05));
            cursor: pointer;
            background: #e0e0e0;
        }

        .content {
            flex: 1;
            overflow-y: auto;
            padding: 1rem;
        }
    `;

    render() {
        return html`
            <div class="overlay" @click=${this._close}></div>
            <div class="panel" style="width: ${this.width}">
                <header>
                    <span>${this.header}</span>
                    <sdb-content-icon
                        aria-label="Close"
                        icon="fal fa-xmark"
                        size="24"
                        @click=${this._close}>
                    </sdb-content-icon>
                </header>
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        `;
    }

    updated(changes) {
        if (changes.has("opened")) {
            this.dispatchEvent(
                new CustomEvent(this.opened ? "panel-opened" : "panel-closed", {
                    detail: { opened: this.opened },
                    bubbles: true,
                    composed: true,
                })
            );
        }
    }

    _close() {
        this.opened = false;
    }
}
